var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader__loader"})])}]

export { render, staticRenderFns }